export default __webpack_public_path__ + "static/media/Aviso.ed924dd1.svg";